export const defaultRule = (path: string, pathExtract: string) => RegExp(`${pathExtract}`).test(path);
